import type { NavigationGuard } from 'vue-router'
import { useAuth } from '@/stores/auth'

export const authGuard: NavigationGuard = async (to) => {
    if (to.meta?.public) return true

    const auth = useAuth()

    if (!auth.ready) {
        await auth.ensureCsrf().catch(() => {})
        await auth.fetchUser({ silent401: true })
    }

    if (!auth.user) {
        if (to.name !== 'login') {
            return { name: 'login', query: { redirect: to.fullPath } }
        }
    }

    return true
}
